import {Box, BoxProps, Image, Link, Text, VStack} from '@chakra-ui/react'
import sponsorImage from '../../assets/sponsor.png'

interface SponsorProps extends BoxProps {
  noSponsor?: boolean
}

const Sponsor = ({noSponsor = true, ...props}: SponsorProps) => (
  <Box p={4} bg='white' maxW='300px' {...props}>
    <VStack spacing={2}>
      {noSponsor ? (
        <>
          <Image
            src='/assets/pdl-2026.jpg'
            alt='Prix de Lausanne 2026'
            objectFit='contain'
            width='100%'
            height='auto'
            sx={{
              maskImage: 'radial-gradient(ellipse 85% 85% at center, black 50%, transparent 100%)',
              WebkitMaskImage:
                'radial-gradient(ellipse 85% 85% at center, black 50%, transparent 100%)',
            }}
          />
          <Text fontSize='sm' color='gray.500' fontWeight='medium' textAlign='center'>
            54th edition • February 1-8, 2026
          </Text>
          <Link
            href='https://www.prixdelausanne.org'
            isExternal
            fontSize='xs'
            color='brand.accent'
            _hover={{textDecoration: 'underline'}}>
            www.prixdelausanne.org
          </Link>
        </>
      ) : (
        <>
          <Text fontSize='sm' color='gray.600' fontStyle='italic' textAlign='center'>
            With the generous support of
          </Text>
          <Image src={sponsorImage} alt='Sponsor' objectFit='contain' width='100%' height='auto' />
        </>
      )}
    </VStack>
  </Box>
)

export default Sponsor
